module.exports = __webpack_public_path__ + "static/media/30-days.66ce0ebe.svg";